import { combineReducers, configureStore } from '@reduxjs/toolkit';
import  login from './component/security/slice-login';
import commonupload from './component/common/slice-upload';
import master from './component/common/slice-master';
import datatable from './component/common/slice-datatable';

const rootReducer = combineReducers({
  login,
  commonupload,
  master,
  datatable,
  httpapierros: (state:any={}, payload:any={type: 'NOTDHENDD', data: 1}) => {
  
  return state;
},

})

export const setupStore = (preloadedState?:any) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
